<template>
    <div class="home container">
        <v-sheet class="smc-sheet-transparent">
            <div class="my-6 py-6"></div>
            <ValidationObserver ref="validationObserver">
                <v-form
                    v-model="valid"
                    ref="form"
                    lazy-validation
                    @submit="submit($event)"
                >
                    <v-card class="smc-card-dialog">
                        <v-card-title class="smc-card-dialog-title primary white--text">
                            <span class="mx-auto">Contact Us</span>
                        </v-card-title>
                        <v-card-text>
                            <iframe
                                src="https://forms.zohopublic.com/servicemycar/form/ServiceMyCarContact/formperma/oP4H60WP_sLD1NKP3dZho-lDrd6raeHhrsNOI32Vr88"
                                width="100%"
                                :height="$vuetify.breakpoint.xsOnly ? 600 : 450"
                                style="border:0;"
                                allowfullscreen=""
                                loading="lazy"
                            />
                        </v-card-text>
                    </v-card>
                </v-form>
            </ValidationObserver>
            <div class="my-6 py-6"></div>
        </v-sheet>
        <v-snackbar v-model="confirmSnackbar" color="primary">
            We've received your request.
            <template #action="{ attrs }">
                <v-btn
                    text
                    v-bind="attrs"
                    @click="confirmSnackbar = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha';
import validate from '@/mixins/validator';
import { contactService } from '@/services';
import vehicleSearch from '@/components/vehicle-search';

export default {
    name: 'contact',
    mixins: [validate],
    data: () => {
        return {
            valid: false,
            loading: false,
            recaptchaVerified: false,
            recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY_V2_CHECKBOX,
            contact: {
                name: '',
                emailAddress: '',
                message: '',
            },
            confirmSnackbar: false,
            socialLinks: {
                facebook: process.env.VUE_APP_SOCIAL_FACEBOOK,
                twitter: process.env.VUE_APP_SOCIAL_TWITTER,
                instagram: process.env.VUE_APP_SOCIAL_INSTAGRAM,
                linkedin: process.env.VUE_APP_SOCIAL_LINKEDIN,
            },
            contactNumber: process.env.VUE_APP_CONTACT_NUMBER,
        };
    },
    components: {
        VueRecaptcha,
        vehicleSearch,
    },
    methods: {
        async submit($event) {
            $event.preventDefault();

            if (this.$refs.form.validate()) {
                this.loading = true;
                let result = await contactService.submitContact(this.contact);
                if (result) {
                    if (result.status === 200) {
                        this.confirmSnackbar = true;
                    }
                }

                this.loading = false;
            }
        },
        recaptchaOnVerify() {
            this.recaptchaVerified = true;
        },
        recaptchaOnExpired() {
            this.recaptchaVerified = false;
        },
        recaptchaOnError() {
            this.recaptchaVerified = false;
        },
    },
};
</script>

<style scoped>
@import "../assets/scss/vuetify-elements/card.scss";
@import "../assets/scss/vuetify-elements/sheet.scss";
</style>
